import {renderElement} from "../../utils/common";

const addFiles = ({form, state}) => {
  const addFileElement = form.querySelector(`.js-add-file`);
  const addFilesList = form.querySelector(`.js-add-file-list`);

  const FILE_TYPES = [`jpg`, `jpeg`, `png`];
  const MAX_FILE_SIZE = 500000;

  const getTemplateFileImg = (src) => `<li class="application__downloaded-image js-image-item">
    <img class="application__downloaded-img" src="${src}" width="98" height="98"
      alt="первое загруженное фото">
    <button class="application__downloaded-del js-image-remove" type="button" aria-label="Удалить фото"></button>
  </li>`;

  const getTemplateFileName = (name) => `<li class="application__downloaded-image application__downloaded-image--not-image js-image-item">
    ${name}
    <button class="application__downloaded-del js-image-remove" type="button" aria-label="Удалить файл"></button>
  </li>`;

  const addFile = (file) => {
    state.files.push(file);
  };

  const removeFile = (index) => state.files.splice(index, 1);

  const handleChange = (evt) => {
    const files = evt.target.files;

    if (!files.length) {
      return;
    }

    for (const key in files) {
      if (key === `length`) {
        break;
      }

      const file = files[key];

      let reader = new FileReader();

      addFile(file);

      reader.addEventListener(`load`, () => {
        if (file.type.includes(`image`)) {
          renderElement(addFilesList, getTemplateFileImg(reader.result));
        } else {
          renderElement(addFilesList, getTemplateFileName(file.name));
        }
      });

      reader.readAsDataURL(file);
    }

    evt.target.value = ``;
  };

  if (addFileElement) {
    const fileChooserElement = addFileElement.querySelector(`.js-add-file-input`);

    fileChooserElement.addEventListener(`change`, handleChange);

    addFilesList.addEventListener(`click`, (evt) => {
      if (evt.target.classList.contains(`js-image-remove`)) {
        const files = addFilesList.querySelectorAll(`.js-image-item`);
        let fileIndex;

        files.forEach((element, index) => {
          if (element.querySelector(`.js-image-remove`) === evt.target) {
            fileIndex = index;
          }
        });

        files[fileIndex].remove();

        removeFile(fileIndex);
      }
    });

    form.addEventListener(`reset`, () => {
      state.files = [];
      addFilesList.querySelectorAll(`.js-image-item`).forEach((image) => image.remove());
    });
  }
};

export default addFiles;
